<template>
  <div class="fondoEspeleotema">
    <HeaderShowCol/>
    <div class="contenedor">
      <div class="header">
        <p>{{nomCol}}</p>
        <div class="atras" @click="atras">&ltrif;</div>
      </div>
      <!-- <div class="cuerpo" :style="{ overflow: controlScroll }"> -->
      <div class="cuerpo" :style="{ overflow: controlScroll }">
        <component
          :is="shoCol"
          @scrollHidden="quitaScroll()"
          @NoScrollHidden="ponScroll()"
        ></component>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderShowCol from '../components/HeaderShowCol.vue'
import ShowPubPer from '../components/ShowPubPer.vue'
import ShowLibros from '../components/ShowLibros.vue'
import ShowCongPonen from '../components/ShowCongPonen.vue'
import ShowTesisY from '../components/ShowTesisY.vue'
import ShowHemeros from '../components/ShowHemeros.vue'
import ShowSeparatas from '../components/ShowSeparatas.vue'
import ShowSellos from '../components/ShowSellos.vue'
import ShowPostales from '../components/ShowPostales.vue'
import ShowMiscel from '../components/ShowMiscel.vue'
import ShowCatastro from '../components/ShowCatastro.vue'
import ShowDiccionario from '../components/ShowDiccionario.vue'
export default {
  props: {
    nomCol2: String
  },
  components: {
    HeaderShowCol,
    ShowPubPer,
    ShowLibros,
    ShowCongPonen,
    ShowTesisY,
    ShowHemeros,
    ShowSeparatas,
    ShowSellos,
    ShowPostales,
    ShowMiscel,
    ShowCatastro,
    ShowDiccionario
  },
  name: 'VistaCol',
  methods: {
    atras: function () {
      this.$router.go(-1)
    },
    quitaScroll () {
      this.scrollMode = 'hidden'
    },
    ponScroll () {
      this.scrollMode = 'auto'
    }
  },
  data () {
    return {
      scrollMode: 'hidden'
    }
  },
  computed: {
    nomCol () {
      if (this.$route.params.nomCol === 'Diccionario') {
        return 'Diccionario'
      } else {
        if (this.$route.params.nomCol === 'Catastro') {
          return 'Catastro'
        } else {
          return this.$route.params.nomCol
        }
      }
    },
    shoCol () {
      if (this.$route.params.showCol === 'diccionario') {
        return 'ShowDiccionario'
      } else {
        if (this.$route.params.showCol === 'catastro') {
          return 'ShowCatastro'
        } else {
          return this.$route.params.showCol
        }
      }
    },
    controlScroll () {
      return this.scrollMode
    }
  }
}
</script>

<style scoped>
*{
  margin: 0;
  padding: 0;
}
.fondoEspeleotema{
    background-image: url("../assets/fondos/FondoEspeleotemaBR.jpg");
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    /* background-position: 35% 0% ; */
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: cover;
    height: 100vh;
    width: 100%;
    overflow-y: hidden;
    font-family: SegoeL;
}
.contenedor{
  height:89.5vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* border: solid 1px greenyellow; */
}
.header{
  width: 100%;
  max-width: 900px;
  height: auto;
  background-color: var(--azul2);
  color: var(--na);
  min-height: 50px;
  margin-top: 5px;
  padding-top:10px;
  padding-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header p{
  font-family: SegoeL;
  font-size: 26px;
  text-align: left;
  padding-left: 20px;
  padding-top: 4px;
  padding-bottom: 5px;
  /* border: 0.5px solid darkorange; */
}
.cuerpo{
  background-color:rgba(179, 188, 192, 0.7);
  max-width: 900px;
  width: 100%;
  height: 100%;
  /* border: solid 1px rgb(255, 47, 196); */
}
.atras{
  font-family: OpenL;
  font-size: 35px;
  /* position: relative; */
  /* right: 10px; */
  color:white;
  /* top: 10px; */
  padding-right: 4px;
  width: 35px;
  height: 35px;
  /* border-radius: 20px; */
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  /* border: solid 1px rgba(1, 117, 163, 0); */
  transition: all 0.5s ease-out;
  /* border: 0.5px solid darkorange; */
}
.atras:hover{
  /* border-color: white; */
  /* background-color: rgb(253, 242, 205, 0.2); */
  /* border: solid 1px rgba(1, 117, 163, 0.4); */
  transform: translateX(-6px);
}
@media screen and (max-width: 576px){
  .header{
    /* width: 100%; */
    /* max-width: 900px; */
    height: auto;
    min-height: 38px;
    /* margin-top: 5px; */
    padding-top:8px;
    padding-bottom: 8px;
  }
  .header p{
  /* font-family: SegoeL; */
  font-size: 22px;
  font-weight: 600;
  /* text-align: left; */
  /* padding-left: 20px; */
  /* padding-top: 4px; */
  /* padding-bottom: 5px; */
  /* border: 0.5px solid darkorange; */
}
}
</style>
